import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function isHexColor(hex) {
  var replaced = hex.replace("#", "");
  return typeof replaced === "string" && replaced.length === 6 && !Number.isNaN(Number("0x".concat(replaced)));
}

function hexToRgba(color) {
  var replaced = color.replace("#", "");
  var parsed = parseInt(replaced, 16);
  var r = parsed >> 16 & 255;
  var g = parsed >> 8 & 255;
  var b = parsed & 255;
  return {
    r: r,
    g: g,
    b: b,
    a: 1
  };
}

function rgbStringToRgba(color) {
  var _color$replace$split$ = color.replace(/[^0-9,.]/g, "").split(",").map(Number),
      _color$replace$split$2 = _slicedToArray(_color$replace$split$, 4),
      r = _color$replace$split$2[0],
      g = _color$replace$split$2[1],
      b = _color$replace$split$2[2],
      a = _color$replace$split$2[3];

  return {
    r: r,
    g: g,
    b: b,
    a: a || 1
  };
}

function toRgba(color) {
  if (isHexColor(color)) {
    return hexToRgba(color);
  }

  if (color.startsWith("rgb")) {
    return rgbStringToRgba(color);
  }

  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}

export { toRgba };